export type NameInfo = {
  name: string
  kind: 'free' | 'premium'
  expiry: bigint
  available: boolean
}

export const l1Node = '0x72b414450a3ee811aa787f22943b2863e0160fa64e8bf72d74b9a8cc60588249'
export const oneBillionYears = 31557000000000000n
